import React from "react";
import { NotImplemented } from "pages/PayRoll/Shared/NotImplemented";

// Placeholder until Payment History is built. Reached from
// Payroll > Disbursement > Payment History in the sidebar flyout.
export const DisbursementPaymentHistory = () => <NotImplemented title="Payment History" />;
